import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation
} from '@angular/core';
import { AccordionModule, ButtonModule } from '@com-delta-idp/mnx-ui-kit';
import { CompanySelection } from '../business/models/business-profile-selector.models';
import { PersonalProfileSelectorView } from './models/personal-profile-selector.interface';

@Component({
  selector: 'idp-personal-profile-selector',
  standalone: true,
  templateUrl: './personal-profile-selector.component.html',
  styleUrls: ['./personal-profile-selector.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [CommonModule, ButtonModule, AccordionModule]
})
export class PersonalProfileSelectorComponent implements OnInit {
  @Input() pageData = {} as PersonalProfileSelectorView;
  @Input() personalStateSelected = false;
  @Input() enableMachCoreProfileSelector = false;
  @Output() personalProfileSelected = new EventEmitter<CompanySelection>();
  @Output() analyticsEvent = new EventEmitter<Event>();
  active = this.personalStateSelected;

  ngOnInit() {
    this.active = this.personalStateSelected;
  }

  onClick(event?: Event): void {
    if (event) {
      this.analyticsEvent.emit(event);
    }

    const personalProfile: CompanySelection = {
      companyName: this.pageData.firstName,
      permType: 'P',
      accountIndex: 0,
      corporateId: '',
      displayInlineText: '',
      isOaSmeAccount: false,
      partnerId: '',
      restrictOnePax: false,
      disableMiles: false
    };
    this.personalProfileSelected.emit(personalProfile);
    this.active = this.personalStateSelected;
  }
}
